import React from 'react';

type OptimizedImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string;
  widths?: number[]; // unused in simplified mode, kept for API compatibility
  sizes?: string;    // unused in simplified mode, kept for API compatibility
  highPriority?: boolean;
  includeAlternativeFormats?: boolean; // when false, do not emit avif/webp <source>
};

const DEFAULT_WIDTHS = [480, 640, 768];

const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  widths = DEFAULT_WIDTHS,
  sizes = '100vw',
  highPriority = false,
  includeAlternativeFormats = true,
  loading,
  decoding = 'async',
  ...imgProps
}) => {
  // Safety-first: only use non-suffixed AVIF/WebP to avoid 404s; rely on plain src for fallback.
  const avifSingle = src.replace(/\.(jpe?g|png)$/i, '.avif');
  const webpSingle = src.replace(/\.(jpe?g|png)$/i, '.webp');

  const finalLoading = highPriority ? 'eager' : (loading || 'lazy');
  const fetchPriority = highPriority ? 'high' : (imgProps as any).fetchPriority;

  return (
    <picture>
      {includeAlternativeFormats && <source type="image/avif" srcSet={avifSingle} />}
      {includeAlternativeFormats && <source type="image/webp" srcSet={webpSingle} />}
      <img
        src={src}
        alt={alt}
        loading={finalLoading as any}
        decoding={decoding as any}
        fetchPriority={fetchPriority as any}
        {...imgProps}
      />
    </picture>
  );
};

export default OptimizedImage;


